var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "change-owner-config" }, [
    _c(
      "div",
      { staticClass: "config-field" },
      [
        _c("label", [
          _vm._v(_vm._s(_vm.$t("contactModuleRules.changeOwnerConfig.method"))),
        ]),
        _vm._v(" "),
        _c(
          "a-radio-group",
          {
            on: { change: _vm.onMethodChange },
            model: {
              value: _vm.localConfig.method,
              callback: function ($$v) {
                _vm.$set(_vm.localConfig, "method", $$v)
              },
              expression: "localConfig.method",
            },
          },
          [
            _c("a-radio-button", { attrs: { value: "static" } }, [
              _vm._v(
                _vm._s(_vm.$t("contactModuleRules.changeOwnerConfig.static"))
              ),
            ]),
            _vm._v(" "),
            _c("a-radio-button", { attrs: { value: "algorithmic" } }, [
              _vm._v(
                _vm._s(
                  _vm.$t("contactModuleRules.changeOwnerConfig.algorithmic")
                )
              ),
            ]),
            _vm._v(" "),
            _c("a-radio-button", { attrs: { value: "random" } }, [
              _vm._v(
                _vm._s(_vm.$t("contactModuleRules.changeOwnerConfig.random"))
              ),
            ]),
          ],
          1
        ),
      ],
      1
    ),
    _vm._v(" "),
    _vm.localConfig.method === "static"
      ? _c("div", { staticClass: "static-config" }, [
          _c(
            "div",
            { staticClass: "config-field" },
            [
              _c("label", [
                _vm._v(
                  _vm._s(
                    _vm.$t("contactModuleRules.changeOwnerConfig.userSelect")
                  )
                ),
              ]),
              _vm._v(" "),
              _c(
                "a-checkbox",
                {
                  on: { change: _vm.onOwnerlessChange },
                  model: {
                    value: _vm.isOwnerless,
                    callback: function ($$v) {
                      _vm.isOwnerless = $$v
                    },
                    expression: "isOwnerless",
                  },
                },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(
                        _vm.$t(
                          "contactModuleRules.changeOwnerConfig.assignOwnerless"
                        )
                      ) +
                      "\n            "
                  ),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          !_vm.isOwnerless
            ? _c(
                "div",
                { staticClass: "config-field" },
                [
                  _c(
                    "a-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        "show-search": "",
                        placeholder: _vm.$t(
                          "contactModuleRules.changeOwnerConfig.selectUser"
                        ),
                        "filter-option": _vm.filterOption,
                      },
                      on: { change: _vm.emitChange },
                      model: {
                        value: _vm.localConfig.staticUserId,
                        callback: function ($$v) {
                          _vm.$set(_vm.localConfig, "staticUserId", $$v)
                        },
                        expression: "localConfig.staticUserId",
                      },
                    },
                    _vm._l(_vm.users, function (user) {
                      return _c(
                        "a-select-option",
                        { key: user._id, attrs: { value: user._id } },
                        [
                          _vm._v(
                            "\n                    " +
                              _vm._s(user.name) +
                              "\n                "
                          ),
                        ]
                      )
                    }),
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.localConfig.method === "algorithmic"
      ? _c("div", { staticClass: "algorithmic-config" }, [
          _c(
            "div",
            { staticClass: "config-field" },
            [
              _c("label", [
                _vm._v(
                  _vm._s(
                    _vm.$t("contactModuleRules.changeOwnerConfig.userList")
                  )
                ),
              ]),
              _vm._v(" "),
              _c(
                "a-checkbox",
                {
                  on: { change: _vm.onVisibilityControlChange },
                  model: {
                    value: _vm.localConfig.useVisibilityControl,
                    callback: function ($$v) {
                      _vm.$set(_vm.localConfig, "useVisibilityControl", $$v)
                    },
                    expression: "localConfig.useVisibilityControl",
                  },
                },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(
                        _vm.$t(
                          "contactModuleRules.changeOwnerConfig.channelAccessUsers"
                        )
                      ) +
                      "\n            "
                  ),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          !_vm.localConfig.useVisibilityControl
            ? _c(
                "div",
                { staticClass: "config-field" },
                [
                  _c(
                    "a-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        mode: "multiple",
                        placeholder: _vm.$t(
                          "contactModuleRules.changeOwnerConfig.selectUsers"
                        ),
                        "filter-option": _vm.filterOption,
                      },
                      on: { change: _vm.emitChange },
                      model: {
                        value: _vm.localConfig.userList,
                        callback: function ($$v) {
                          _vm.$set(_vm.localConfig, "userList", $$v)
                        },
                        expression: "localConfig.userList",
                      },
                    },
                    _vm._l(_vm.users, function (user) {
                      return _c(
                        "a-select-option",
                        { key: user._id, attrs: { value: user._id } },
                        [
                          _vm._v(
                            "\n                    " +
                              _vm._s(user.name) +
                              "\n                "
                          ),
                        ]
                      )
                    }),
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "config-field" },
            [
              _c("label", [
                _vm._v(
                  _vm._s(
                    _vm.$t("contactModuleRules.changeOwnerConfig.algorithm")
                  )
                ),
              ]),
              _vm._v(" "),
              _c(
                "a-select",
                {
                  staticStyle: { width: "100%" },
                  on: { change: _vm.emitChange },
                  model: {
                    value: _vm.localConfig.algorithmSettings.algorithm,
                    callback: function ($$v) {
                      _vm.$set(
                        _vm.localConfig.algorithmSettings,
                        "algorithm",
                        $$v
                      )
                    },
                    expression: "localConfig.algorithmSettings.algorithm",
                  },
                },
                [
                  _c("a-select-option", { attrs: { value: "least_contact" } }, [
                    _vm._v(
                      _vm._s(
                        _vm.$t(
                          "contactModuleRules.changeOwnerConfig.leastContact"
                        )
                      )
                    ),
                  ]),
                  _vm._v(" "),
                  _c("a-select-option", { attrs: { value: "round_robin" } }, [
                    _vm._v(
                      _vm._s(
                        _vm.$t(
                          "contactModuleRules.changeOwnerConfig.roundRobin"
                        )
                      )
                    ),
                  ]),
                  _vm._v(" "),
                  _c("a-select-option", { attrs: { value: "ordered" } }, [
                    _vm._v(
                      _vm._s(
                        _vm.$t("contactModuleRules.changeOwnerConfig.ordered")
                      )
                    ),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _vm.localConfig.algorithmSettings.algorithm === "ordered"
                ? _c("small", [
                    _vm._v(
                      "\n                " +
                        _vm._s(
                          _vm.$t(
                            "contactModuleRules.changeOwnerConfig.orderedHint"
                          )
                        ) +
                        "\n            "
                    ),
                  ])
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _vm.localConfig.algorithmSettings.algorithm !== "ordered"
            ? _c(
                "div",
                { staticClass: "config-field" },
                [
                  _c("label", [
                    _vm._v(
                      _vm._s(
                        _vm.$t("contactModuleRules.changeOwnerConfig.dateRange")
                      )
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "a-select",
                    {
                      staticStyle: { width: "100%" },
                      on: { change: _vm.onDateRangeChange },
                      model: {
                        value: _vm.localConfig.algorithmSettings.dateRange,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.localConfig.algorithmSettings,
                            "dateRange",
                            $$v
                          )
                        },
                        expression: "localConfig.algorithmSettings.dateRange",
                      },
                    },
                    [
                      _c("a-select-option", { attrs: { value: "today" } }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t("contactModuleRules.changeOwnerConfig.today")
                          )
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "a-select-option",
                        { attrs: { value: "last_7_days" } },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "contactModuleRules.changeOwnerConfig.last7Days"
                              )
                            )
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "a-select-option",
                        { attrs: { value: "last_30_days" } },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "contactModuleRules.changeOwnerConfig.last30Days"
                              )
                            )
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "a-select-option",
                        { attrs: { value: "last_n_min" } },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "contactModuleRules.changeOwnerConfig.lastNMin"
                              )
                            )
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "a-select-option",
                        { attrs: { value: "last_n_hours" } },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "contactModuleRules.changeOwnerConfig.lastNHours"
                              )
                            )
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "a-select-option",
                        { attrs: { value: "last_n_days" } },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "contactModuleRules.changeOwnerConfig.lastNDays"
                              )
                            )
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.localConfig.algorithmSettings.algorithm !== "ordered" &&
          _vm.isCustomDateRange
            ? _c(
                "div",
                { staticClass: "config-field" },
                [
                  _c("label", [_vm._v(_vm._s(_vm.dateRangeValueLabel))]),
                  _vm._v(" "),
                  _c("a-input-number", {
                    staticStyle: { width: "100%" },
                    attrs: { min: 1, step: 1 },
                    on: { change: _vm.emitChange },
                    model: {
                      value: _vm.localConfig.algorithmSettings.dateRangeValue,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.localConfig.algorithmSettings,
                          "dateRangeValue",
                          $$v
                        )
                      },
                      expression:
                        "localConfig.algorithmSettings.dateRangeValue",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "config-field" },
            [
              _c(
                "a-checkbox",
                {
                  on: { change: _vm.emitChange },
                  model: {
                    value: _vm.localConfig.algorithmSettings.checkOnlineStatus,
                    callback: function ($$v) {
                      _vm.$set(
                        _vm.localConfig.algorithmSettings,
                        "checkOnlineStatus",
                        $$v
                      )
                    },
                    expression:
                      "localConfig.algorithmSettings.checkOnlineStatus",
                  },
                },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(
                        _vm.$t(
                          "contactModuleRules.changeOwnerConfig.onlyOnline"
                        )
                      ) +
                      "\n            "
                  ),
                ]
              ),
            ],
            1
          ),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.localConfig.method === "random"
      ? _c("div", { staticClass: "random-config" }, [
          _c(
            "div",
            { staticClass: "config-field" },
            [
              _c("label", [
                _vm._v(
                  _vm._s(
                    _vm.$t("contactModuleRules.changeOwnerConfig.userList")
                  )
                ),
              ]),
              _vm._v(" "),
              _c(
                "a-checkbox",
                {
                  on: { change: _vm.onVisibilityControlChange },
                  model: {
                    value: _vm.localConfig.useVisibilityControl,
                    callback: function ($$v) {
                      _vm.$set(_vm.localConfig, "useVisibilityControl", $$v)
                    },
                    expression: "localConfig.useVisibilityControl",
                  },
                },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(
                        _vm.$t(
                          "contactModuleRules.changeOwnerConfig.channelAccessUsers"
                        )
                      ) +
                      "\n            "
                  ),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          !_vm.localConfig.useVisibilityControl
            ? _c(
                "div",
                { staticClass: "config-field" },
                [
                  _c(
                    "a-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        mode: "multiple",
                        placeholder: _vm.$t(
                          "contactModuleRules.changeOwnerConfig.selectUsers"
                        ),
                        "filter-option": _vm.filterOption,
                      },
                      on: { change: _vm.emitChange },
                      model: {
                        value: _vm.localConfig.userList,
                        callback: function ($$v) {
                          _vm.$set(_vm.localConfig, "userList", $$v)
                        },
                        expression: "localConfig.userList",
                      },
                    },
                    _vm._l(_vm.users, function (user) {
                      return _c(
                        "a-select-option",
                        { key: user._id, attrs: { value: user._id } },
                        [
                          _vm._v(
                            "\n                    " +
                              _vm._s(user.name) +
                              "\n                "
                          ),
                        ]
                      )
                    }),
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ])
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "config-field zoho-sync" },
      [
        _c(
          "a-checkbox",
          {
            on: { change: _vm.emitChange },
            model: {
              value: _vm.localConfig.syncToZoho,
              callback: function ($$v) {
                _vm.$set(_vm.localConfig, "syncToZoho", $$v)
              },
              expression: "localConfig.syncToZoho",
            },
          },
          [
            _vm._v(
              "\n            " +
                _vm._s(_vm.$t("contactModuleRules.changeOwnerSyncToZoho")) +
                "\n        "
            ),
          ]
        ),
        _vm._v(" "),
        _c("small", [
          _vm._v(_vm._s(_vm.$t("contactModuleRules.changeOwnerZohoHint"))),
        ]),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }